import React from "react";
import runner from "../components/images/runner.jpg";
import mvp from "../components/images/mvp.jpg";
import fours from "../components/images/fours.jpg";
import dot from "../components/images/dot.jpg";
import cap from "../components/images/cap.jpg";
import rcbLogo from "../components/images/rcb.png";
import gtLogo from "../components/images/gt.png";
import motera from "../components/images/motera.jpeg";

const FinalMatchReport = () => {
  return (
    <div className="px-4 py-8 min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 md:px-12">
      <div className="mx-auto max-w-7xl">
        {/* Hero Header */}
        <div className="mb-12 text-center">
          <h1 className="mb-4 text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-blue-600 to-purple-600 md:text-6xl">
            TATA IPL 2026 Final Match Report
          </h1>
          <p className="mb-2 text-2xl font-semibold text-gray-700 dark:text-gray-300">
            Royal Challengers Bengaluru vs Gujarat Titans
          </p>
          <p className="mb-6 text-xl text-gray-600 dark:text-gray-400">
            31 May, 2026 · Narendra Modi Stadium, Ahmedabad
          </p>

          {/* Teams & Result Card */}
          <div className="p-8 mx-auto max-w-5xl bg-white rounded-3xl shadow-2xl dark:bg-gray-800">
            <div className="flex flex-col gap-8 justify-around items-center mb-6 md:flex-row">
              <div className="flex flex-col items-center">
                <img
                  src={rcbLogo}
                  alt="RCB"
                  className="object-contain mb-4 w-32 h-32"
                />
                <h3 className="text-2xl font-bold text-gray-800 dark:text-white">
                  RCB
                </h3>
                <p className="mt-2 text-3xl font-extrabold text-green-600">
                  161/5
                </p>
                <p className="text-gray-600 dark:text-gray-300">(18 overs)</p>
              </div>

              <div className="flex flex-col items-center">
                <p className="mb-2 text-3xl font-extrabold text-gray-800 dark:text-white">
                  VS
                </p>
                <div className="px-8 py-3 text-2xl font-bold text-white bg-gradient-to-r from-green-500 to-blue-500 rounded-full shadow-lg">
                  RCB Won by 5 Wickets
                </div>
                <p className="mt-2 text-lg text-gray-600 dark:text-gray-300">
                  Defended Champions!
                </p>
              </div>

              <div className="flex flex-col items-center">
                <img
                  src={gtLogo}
                  alt="GT"
                  className="object-contain mb-4 w-32 h-32"
                />
                <h3 className="text-2xl font-bold text-gray-800 dark:text-white">
                  GT
                </h3>
                <p className="mt-2 text-3xl font-extrabold text-gray-800 dark:text-white">
                  155/8
                </p>
                <p className="text-gray-600 dark:text-gray-300">(20 overs)</p>
              </div>
            </div>

            <img
              src={motera}
              alt="Narendra Modi Stadium"
              className="object-cover mb-6 w-full h-64 rounded-2xl shadow-xl"
            />

            <div className="grid grid-cols-1 gap-4 md:grid-cols-5">
              <div className="flex flex-col items-center p-4 bg-gradient-to-br from-yellow-100 to-yellow-200 rounded-2xl dark:from-yellow-900/30 dark:to-yellow-800/30">
                <p className="mb-1 text-sm font-semibold text-gray-700 dark:text-gray-300">
                  Toss
                </p>
                <p className="text-lg font-bold text-gray-800 dark:text-white">
                  RCB (bowl first)
                </p>
              </div>
              <div className="flex flex-col items-center p-4 bg-gradient-to-br from-blue-100 to-blue-200 rounded-2xl dark:from-blue-900/30 dark:to-blue-800/30">
                <p className="mb-1 text-sm font-semibold text-gray-700 dark:text-gray-300">
                  Player of Match
                </p>
                <p className="text-lg font-bold text-gray-800 dark:text-white">
                  Virat Kohli
                </p>
              </div>
              <div className="flex flex-col items-center p-4 bg-gradient-to-br from-green-100 to-green-200 rounded-2xl dark:from-green-900/30 dark:to-green-800/30">
                <p className="mb-1 text-sm font-semibold text-gray-700 dark:text-gray-300">
                  MVP of Season
                </p>
                <p className="text-lg font-bold text-gray-800 dark:text-white">
                  Vaibhav Sooryavanshi
                </p>
              </div>
              <div className="flex flex-col items-center p-4 bg-gradient-to-br from-purple-100 to-purple-200 rounded-2xl dark:from-purple-900/30 dark:to-purple-800/30">
                <p className="mb-1 text-sm font-semibold text-gray-700 dark:text-gray-300">
                  Purple Cap
                </p>
                <p className="text-lg font-bold text-gray-800 dark:text-white">
                  Kagiso Rabada
                </p>
              </div>
              <div className="flex flex-col items-center p-4 bg-gradient-to-br from-orange-100 to-orange-200 rounded-2xl dark:from-orange-900/30 dark:to-orange-800/30">
                <p className="mb-1 text-sm font-semibold text-gray-700 dark:text-gray-300">
                  Orange Cap
                </p>
                <p className="text-lg font-bold text-gray-800 dark:text-white">
                  Virat Kohli
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {/* Left Column - Text Content */}
          <div className="space-y-6 lg:col-span-2">
            {/* Match Summary */}
            <section className="p-8 bg-white rounded-3xl shadow-xl dark:bg-gray-800">
              <h2 className="flex gap-3 items-center mb-6 text-3xl font-bold text-gray-800 dark:text-white">
                <span className="text-4xl">📋</span> Match Summary
              </h2>
              <div className="space-y-4 leading-relaxed text-gray-700 dark:text-gray-300">
                <p>
                  Royal Challengers Bengaluru (RCB) etched their name deeper
                  into IPL history, defeating Gujarat Titans (GT) by five
                  wickets in the TATA IPL 2026 final at the Narendra Modi
                  Stadium to successfully defend their crown. Chasing 156, RCB
                  reached 161/5 with 12 balls to spare, becoming only the third
                  franchise after Chennai Super Kings and Mumbai Indians to
                  retain the IPL title. The triumph gave RCB their second IPL
                  trophy, taking them level with multiple-title winners and
                  cementing their place among the competition's most successful
                  sides.
                </p>
                <p>
                  Having won the toss, captain Rajat Patidar opted to bowl first
                  — a decision that paid dividends almost immediately. The RCB
                  seamers bulldozed GT’s prominent batting line-up with their
                  short ball ploy. Six of the eight GT batters were out to short
                  length deliveries. The ploy was successfully launched by Josh
                  Hazlewood and Bhuvneshwar Kumar dismissing Shubman Gill and
                  Sai Sudharsan respectively and the GT batters struggled to
                  establish any momentum.
                </p>
                <p>
                  The pattern continued throughout the innings. Nishant Sindhu
                  attempted to counterattack but lost his footing while going
                  for a big hit and holed out on the boundary. With wickets
                  falling at regular intervals, Gujarat found themselves unable
                  to build the partnerships that had defined their campaign.
                  Washington Sundar stood alone amidst the collapse. The
                  left-hander produced a composed unbeaten 50 off 37 deliveries,
                  holding the innings together while wickets tumbled around him.
                  His resistance was crucial in dragging GT to a respectable
                  total after they had repeatedly lost momentum.
                </p>
                <p>
                  The lower order briefly threatened a late flourish. Arshad
                  Khan struck 15 off six balls before falling to Hazlewood,
                  Rahul Tewatia managed only seven before Rasikh Salam struck,
                  while Jason Holder's dismissal for seven gave Bhuvneshwar his
                  28th wicket of the season. Rashid Khan's brief cameo ended
                  when Rasikh struck again as GT finished on 155/8.
                </p>
              </div>
            </section>

            {/* RCB Innings */}
            <section className="p-8 bg-white rounded-3xl shadow-xl dark:bg-gray-800">
              <h2 className="flex gap-3 items-center mb-6 text-3xl font-bold text-gray-800 dark:text-white">
                <span className="text-4xl">🏏</span> RCB's Chase Masterclass
              </h2>
              <div className="space-y-4 leading-relaxed text-gray-700 dark:text-gray-300">
                <p>
                  RCB's response could not have begun in more emphatic fashion.
                  Virat Kohli and Venkatesh Iyer tore into the chase, bringing
                  up the team fifty in just 3.3 overs — the fastest fifty by a
                  side in an IPL final. The opening partnership immediately
                  seized control of the contest and placed GT under immense
                  pressure.
                </p>
                <p>
                  Iyer's promotion proved a masterstroke. Introduced as an
                  Impact Player later in the game, he smashed 32 off just 16
                  deliveries before Mohammed Siraj finally broke through. Kagiso
                  Rabada then removed Devdutt Padikkal for one, a wicket that
                  secured the Purple Cap for him this season. GT briefly sensed
                  an opening when Rashid Khan dismissed both Rajat Patidar and
                  Krunal Pandya within four deliveries. Tim David also fell
                  after a successful review, giving Gujarat a glimmer of hope.
                </p>
                <p>
                  But Virat Kohli was never let the chase drift. The former
                  captain produced another masterclass under pressure, reaching
                  his half-century in just 25 balls before expertly pacing the
                  remainder of the innings. Mixing calculated aggression with
                  trademark composure, Kohli remained unbeaten on 75 off 42
                  balls, ensuring there would be no late drama. Jitesh Sharma
                  provided calm support at the other end as RCB crossed the
                  finish line with two overs to spare.
                </p>
              </div>
            </section>

            {/* Player Quotes */}
            <section className="p-8 bg-white rounded-3xl shadow-xl dark:bg-gray-800">
              <h2 className="flex gap-3 items-center mb-6 text-3xl font-bold text-gray-800 dark:text-white">
                <span className="text-4xl">💬</span> Post-Match Interviews
              </h2>
              <div className="space-y-6">
                <div className="p-6 bg-gradient-to-br from-red-50 to-red-100 rounded-2xl border-l-4 border-red-500 dark:from-red-900/20 dark:to-red-800/20">
                  <h3 className="mb-2 text-xl font-bold text-gray-800 dark:text-white">
                    Rajat Patidar (RCB Captain)
                  </h3>
                  <p className="leading-relaxed text-gray-700 dark:text-gray-300">
                    "It feels absolutely incredible and hard to put into words
                    because when we arrived here, there were so many memories
                    from last year. Everything was planned clearly, and once we
                    won the toss it made chasing much simpler. The way Bhuvi,
                    Hazlewood, Rasikh, Krunal, Suyash, and Shepherd bowled
                    throughout the tournament was outstanding and they deserve
                    huge credit. I never imagined I would captain RCB and lift
                    the trophy, so it feels like something that was meant to
                    happen and I am truly grateful for it. Compared to last
                    year, we came in with more confidence and it felt like every
                    venue turned into a home ground because of the incredible
                    support from our fans. Personally, the pre tournament
                    preparation helped a lot as I worked on understanding my
                    scoring areas better, and the advice from DK was extremely
                    valuable as he was always there guiding the team."
                  </p>
                </div>

                <div className="p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl border-l-4 border-blue-500 dark:from-blue-900/20 dark:to-blue-800/20">
                  <h3 className="mb-2 text-xl font-bold text-gray-800 dark:text-white">
                    Shubman Gill (GT Captain)
                  </h3>
                  <p className="leading-relaxed text-gray-700 dark:text-gray-300">
                    "Yes, I think if we had got close to one eighty or one
                    ninety, it would have made the match more competitive
                    because those early overs had some movement for the fast
                    bowlers and losing a couple of wickets cost us momentum. We
                    also ended up conceding around fifteen to twenty extra runs
                    in the powerplay which made things tougher later on. Overall
                    though, I am proud of how our bowling unit performed
                    throughout the tournament because we were one of the best
                    sides with the ball. After a couple of early losses we
                    showed great character to come back strongly, which is
                    something the team can take a lot of confidence from. Even
                    though we could not cross the line eventually, I believe
                    every campaign leaves you with learnings and there are
                    always areas to improve, regardless of whether you win the
                    trophy or not."
                  </p>
                </div>

                <div className="p-6 bg-gradient-to-br from-green-50 to-green-100 rounded-2xl border-l-4 border-green-500 dark:from-green-900/20 dark:to-green-800/20">
                  <h3 className="mb-2 text-xl font-bold text-gray-800 dark:text-white">
                    Vaibhav Sooryavanshi (Season MVP)
                  </h3>
                  <p className="leading-relaxed text-gray-700 dark:text-gray-300">
                    "It feels really special to win the award, although doing
                    this interview makes me a bit nervous (laughs). I believe
                    you cannot play every game the same way, you have to adapt
                    to the situation and conditions each time you go out there.
                    One thing I have realised is that staying fit and injury
                    free is very important if I want to perform consistently, so
                    I am focused on improving my fitness as well. The
                    environment in the team has been amazing with seniors and
                    support staff constantly backing me, and that kind of
                    support makes it easier to express myself on the field."
                  </p>
                </div>

                <div className="p-6 bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl border-l-4 border-purple-500 dark:from-purple-900/20 dark:to-purple-800/20">
                  <h3 className="mb-2 text-xl font-bold text-gray-800 dark:text-white">
                    Virat Kohli (Player of the Match)
                  </h3>
                  <p className="leading-relaxed text-gray-700 dark:text-gray-300">
                    "It is the kind of moment you dream about, standing here
                    after winning the IPL because as a player you visualize
                    these situations so many times. When you have a team like
                    this around you, it gives you confidence to handle any
                    pressure situation and that is what modern cricket demands.
                    The competition today is so high that young players
                    constantly push you to improve and find those extra twenty
                    or thirty runs. I had to change my mindset over time to meet
                    those demands and evolve as a batter. Our goal was to finish
                    at the top of the table and we were not concerned about who
                    we would face in the playoffs because as a professional
                    side, the focus is always on performing against whoever is
                    in front of you. Even if I got out early, I believed in the
                    depth of our batting unit to get the job done. There was
                    complete clarity in our approach and we had small targets
                    within the innings to stay on track. Credit also to Venky
                    for stepping in and playing a brilliant role. I always
                    believe we do not just have seven home games but fourteen
                    because the support we get everywhere is incredible, and
                    even here where GT are the home side, the crowd support for
                    RCB was overwhelming."
                  </p>
                </div>
              </div>
            </section>
          </div>

          {/* Right Column - Images & Quick Stats */}
          <div className="space-y-6 lg:col-span-1">
            {/* MVP Card */}
            <div className="p-6 bg-white rounded-3xl shadow-xl dark:bg-gray-800">
              <h3 className="mb-4 text-2xl font-bold text-center text-gray-800 dark:text-white">
                🎖️ 👑 King of IPL 2026
              </h3>
              <img
                src={mvp}
                alt="Vaibhav Sooryavanshi - Season MVP"
                className="object-cover mb-4 w-full h-64 rounded-2xl"
              />
              <p className="text-xl font-bold text-center text-gray-800 dark:text-white">
                Vaibhav Sooryavanshi
              </p>
              <p className="mt-2 text-sm text-center text-gray-600 dark:text-gray-300">
                IPL 2026 Season MVP • 776 Runs • Orange Cap Winner • Emerging
                Player
              </p>
            </div>
            {/* Runner-Up Card */}
            <div className="p-6 bg-white rounded-3xl shadow-xl dark:bg-gray-800">
              <h3 className="mb-4 text-2xl font-bold text-center text-gray-800 dark:text-white">
                🥈 Runner-Up
              </h3>
              <img
                src={runner}
                alt="Runner Up"
                className="object-cover mb-4 w-full h-64 rounded-2xl"
              />
              <p className="text-xl font-bold text-center text-gray-800 dark:text-white">
                Gujarat Titans
              </p>
            </div>

            {/* Purple Cap Card */}
            <div className="p-6 bg-white rounded-3xl shadow-xl dark:bg-gray-800">
              <h3 className="mb-4 text-2xl font-bold text-center text-gray-800 dark:text-white">
                🎩 Purple Cap
              </h3>
              <img
                src={cap}
                alt="Purple Cap"
                className="object-cover mb-4 w-full h-64 rounded-2xl"
              />
              <p className="text-xl font-bold text-center text-gray-800 dark:text-white">
                Kagiso Rabada
              </p>
            </div>

            {/* Most Fours Card */}
            <div className="p-6 bg-white rounded-3xl shadow-xl dark:bg-gray-800">
              <h3 className="mb-4 text-2xl font-bold text-center text-gray-800 dark:text-white">
                4️⃣ Most Fours
              </h3>
              <img
                src={fours}
                alt="Most Fours"
                className="object-cover mb-4 w-full h-64 rounded-2xl"
              />
              <p className="text-xl font-bold text-center text-gray-800 dark:text-white">
                Sai Sudharsan
              </p>
            </div>

            {/* Most Dots Card */}
            <div className="p-6 bg-white rounded-3xl shadow-xl dark:bg-gray-800">
              <h3 className="mb-4 text-2xl font-bold text-center text-gray-800 dark:text-white">
                ⚫ Most Dots
              </h3>
              <img
                src={dot}
                alt="Most Dots"
                className="object-cover mb-4 w-full h-64 rounded-2xl"
              />
              <p className="text-xl font-bold text-center text-gray-800 dark:text-white">
                Mohammed Siraj
              </p>
            </div>
          </div>
        </div>

        {/* Final Conclusion */}
        <section className="p-10 mt-12 text-white bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-3xl shadow-2xl">
          <h2 className="mb-6 text-4xl font-extrabold text-center">
            🏆 Royal Challengers Bengaluru - IPL 2026 Champions!
          </h2>
          <div className="mx-auto max-w-4xl text-lg leading-relaxed">
            <p className="mb-4">
              Royal Challengers Bengaluru crowned themselves IPL 2026 champions,
              successfully defending their title with a composed five-wicket
              victory over the Gujarat Titans in a well-controlled final at
              Ahmedabad.
            </p>
            <p className="mb-4">
              Gujarat Titans never quite found momentum with the bat, managing
              only 155 for 8 on a surface that demanded intent. Early
              breakthroughs from Bhuvneshwar Kumar and Josh Hazlewood put them
              under pressure, while Rasikh Salam’s impressive 3 for 27 through
              the middle overs ensured Gujarat struggled to build partnerships.
              Washington Sundar stood out with a fighting 50 off 37 balls, but
              lacked sustained support as wickets fell at regular intervals.
            </p>
            <p className="mb-4">
              Chasing 156, RCB approached the target with clarity and calm.
              Venkatesh Iyer provided early momentum with a brisk 32 from 16
              balls before Virat Kohli took control of the chase. Kohli produced
              a masterclass under pressure, finishing unbeaten on 75 off 42
              balls, anchoring the innings with precision and authority.
            </p>
            <p className="mb-4">
              Despite a brief wobble where a couple of wickets fell, RCB never
              lost control of the required rate. Tim David’s contribution of 24
              and the finishing touch from Jitesh Sharma ensured there were no
              late hiccups as Bengaluru closed the chase in 18 overs.
            </p>
            <p className="mb-4">
              The victory was built on balance and big-match temperament. RCB
              combined disciplined bowling with a composed chase, underlining
              their consistency and class.
            </p>
            <p className="text-xl font-semibold text-center">
              With this triumph, Royal Challengers Bengaluru cement their status
              as one of the premier sides of the era, defending their crown and
              lifting their second IPL trophy in style.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default FinalMatchReport;
